<template>
  <app-icon icon="ph:lightning-fill" :size="size" />
</template>

<script lang="ts" setup>
defineProps<{
  size?: number;
}>();
</script>
